import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./login.module.css";
import { setAuthTokens } from "../../utils/AuthToken";
import { api } from "../../lib/axios";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [captcha, setCaptcha] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState("");
    const [attempts, setAttempts] = useState(0);
    const [showCaptcha, setShowCaptcha] = useState(false);

    useEffect(() => {
        if (showCaptcha) {
            loadCaptchaEnginge(5);
        }
    }, [showCaptcha]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (showCaptcha) {
            if (!validateCaptcha(captcha)) {
                setError("کد امنیتی اشتباه است");
                loadCaptchaEnginge(5);
                setCaptcha("");
                setLoading(false);
                return;
            }
        }


        try {
                if (!username.trim() || !password.trim()) {
                    setError("نام کاربری و گذرواژه الزامی است");
                    setLoading(false);
                    return;
                }

            const res = await api.post("/auth/glogin/", {
                username,
                password,
                otp_code: otp || undefined,
                captcha_code: showCaptcha ? captcha : undefined,
            });

            const { access_token, refresh_token } = res.data;
            setAuthTokens(access_token, refresh_token);
            window.location.href = "/";
        } catch (err) {
            setAttempts((prev) => {
                const next = prev + 1;
                if (next === 3) setShowCaptcha(true);
                return next;
            });

                setError("نام کاربری یا گذرواژه اشتباه است");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.main}>
            <img src="/logo.svg" alt="logo" className={styles.logo} />

            <div className={styles.title}>
                <div className={styles["main-title"]}>تبدیل گفتار به متن حرفـــــ</div>
                <div className={styles["in-web"]}>
                    <div>حرف با استفاده از هزاران ساعت گفتار با صدای افراد مختلف،</div>
                    <div>زبان فارسی را یاد گرفته است و می‌تواند متن صحبت‌ها را بنویسد.</div>
                </div>
            </div>

            <div className={styles["main-section"]}>
                <form
                    id="login_form"
                    className={styles["my-form-group"]}
                    onSubmit={handleSubmit}
                >
                    <>
                        <div className={styles.text}>لطفا وارد شوید</div>
                        <input
                            type="text"
                            placeholder="نام کاربری"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className={styles.username}
                        />
                        <input
                            type="password"
                            placeholder="گذرواژه"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={styles.password}
                        />
                    </>

                    <div className={styles.otpWrapper}>
                        <label className={styles.otpLabel}>
                            کد یکبار مصرف (در صورت فعال بودن)
                        </label>
                        <input
                            type="text"
                            className={styles.otp}
                            placeholder="کد یکبار مصرف"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                    </div>


                    {showCaptcha && (
                        <div className={styles.captchaWrapper}>
                            <div className={styles.captchaRow}>
                                <LoadCanvasTemplate />
                            </div>

                            <input
                                type="text"
                                className={styles.captchaInput}
                                placeholder="کد امنیتی را وارد کنید"
                                value={captcha}
                                onChange={(e) => setCaptcha(e.target.value)}
                            />
                        </div>
                    )}

                    {error && <p className={styles.error}>{error}</p>}

                    <button type="submit" className={styles.submit} disabled={loading}>
                        {loading ? "در حال ورود..." : "ورود"}
                    </button>
                </form>
            </div>
        </div>

    );
};

export default Login;
